import PropTypes from 'prop-types';
import React, {Component} from 'react';
import cN from 'classnames';

import Row from 'scripts/components/Row';
import Column from 'scripts/components/Column';

import FreeText from './FreeText';
import Number from './Number';
import Matrix from './Matrix';
import Media from './Media';
import Meditation from './Meditation';
import Choice from './Choice';
import Relation from './Relation';
import Table from './Table';
import Slider from './Slider';
import Group from './Group';
import Flanker from './Flanker';


/* eslint-disable quote-props */
export const LessonBlockTypes = {
    'dyad': null,
    'free-text': FreeText,
    'number': Number,
    'information': null,
    'inner-part': null,
    'matrix': Matrix,
    'media': Media,
    'meditation': Meditation,
    'choice': Choice,
    'relation': Relation,
    'table': Table,
    'slider': Slider,
    'group': Group,
    'flanker': Flanker,
};

/**
 * Renders the appropriate block component.
 */
class LessonBlock extends Component {

    /**
     * @param {string} type
     * @param {*} answer
     * @param {*} config
     * @param {*} extra
     * @returns {boolean}
     */
    static canContinue(type, answer, config, extra) {
        const Block = LessonBlockTypes[type];

        return Block ? Block.canContinue(answer, config, extra) : false;
    }

    render() {
        const {type, types, missingInfo, notifyOptionalMissing, onContinue, ...props} = this.props;
        const Block = types[type];

        if (Block) {
            return (
                <Row className={cN('lesson-block text-left', `lesson-block-${type}`, {missing: missingInfo || notifyOptionalMissing})}>
                    <Column size={12}>
                  <Block {...props} missingInfo={missingInfo} notifyOptionalMissing={notifyOptionalMissing} onContinue={onContinue} />
                    </Column>
                </Row>
            );
        }
        return null;
    }
}

LessonBlock.propTypes = {
    type: PropTypes.oneOf(
        Object.keys(LessonBlockTypes),
    ).isRequired,
    types: PropTypes.shape(Object.keys(LessonBlockTypes).reduce((acc, key) => {
        acc[key] = PropTypes.oneOfType([PropTypes.node, PropTypes.func]);
        return acc;
    }, {})),
};

LessonBlock.defaultProps = {
    types: LessonBlockTypes,
};

export default LessonBlock;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonBlock.js